module.exports = __webpack_public_path__ + "img/2.c71b7ac4.png";